import { Login } from './Login.jsx';

export default {
  path: '/login',
  element: <Login />,
  protected: false,
  permission: null,
  standalone: true,
  sidebar: null
};
